<template>
  <div class="relative flex flex-col w-full group">
    <BasePreloader loading border-radius="12px" width="100%" height="189px" />
    <div class="relative flex flex-col w-full h-full z-20 bg-white pt-6 flex-1">
      <BasePreloader
        loading
        border-radius="6px"
        width="100%"
        height="32px"
        preloader-class="mb-2"
      />
      <BasePreloader loading border-radius="6px" width="100px" height="22px" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BasePreloader from "@/modules/Landing/components/Base/Preloader/Preloader.vue";
</script>

<style scoped></style>
